import { api } from './api';

const BASE = '/vendors';

export const vendorsApi = {
  list: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.search)   qs.set('search',   params.search);
    if (params.isActive !== undefined) qs.set('isActive', String(params.isActive));
    if (params.page)     qs.set('page',     String(params.page));
    if (params.limit)    qs.set('limit',    String(params.limit));
    const query = qs.toString();
    return api.get(query ? `${BASE}?${query}` : BASE);
  },

  getById: (id) => api.get(`${BASE}/${id}`),

  create: (data) => api.post(BASE, data),

  update: (id, data) => api.patch(`${BASE}/${id}`, data),

  deactivate: (id) => api.delete(`${BASE}/${id}`),

  migrateAccounts: (dryRun = true) =>
    api.post(`${BASE}/migrate-accounts`, { dryRun }),
};
